import { render, staticRenderFns } from "./copymetermodel.vue?vue&type=template&id=5c3f2114&"
import script from "./copymetermodel.vue?vue&type=script&lang=ts&"
export * from "./copymetermodel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "copymetermodel.vue"
export default component.exports